import { useEffect } from 'react'
import { useTicketsStore } from '@/stores/tickets'
import { TicketCard } from './ticket-card'
import { TicketFilters } from './ticket-filters'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { Loader2, Ticket } from 'lucide-react'

export function TicketList() {
  const { tickets, isLoading, error, fetchTickets } = useTicketsStore()

  useEffect(() => {
    fetchTickets('emaildrafter')
  }, [fetchTickets])

  if (error) {
    return (
      <Card>
        <CardContent className="p-6">
          <div className="text-center text-red-600">
            <p>Fehler beim Laden der Tickets: {error}</p>
          </div>
        </CardContent>
      </Card>
    )
  }

  const statusCounts = tickets.reduce((acc, ticket) => {
    acc[ticket.status] = (acc[ticket.status] || 0) + 1
    return acc
  }, {} as Record<string, number>)

  return (
    <div className="space-y-6">
      {/* Filters */}
      <TicketFilters />

      {/* Tickets List */}
      <Card>
        <CardHeader>
          <CardTitle>Tickets</CardTitle>
        </CardHeader>
        <CardContent>
          {isLoading ? (
            <div className="flex items-center justify-center py-8">
              <Loader2 className="h-6 w-6 animate-spin mr-2" />
              <span>Tickets werden geladen...</span>
            </div>
          ) : tickets.length === 0 ? (
            <div className="text-center py-8 text-muted-foreground">
              <Ticket className="h-12 w-12 mx-auto mb-4 opacity-50" />
              <p>Noch keine Tickets vorhanden.</p>
              <p className="text-sm">Erstellen Sie Ihr erstes Ticket!</p>
            </div>
          ) : (
            <div className="space-y-4">
              {tickets.map((ticket) => (
                <TicketCard key={ticket.id} ticket={ticket} />
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  )
}